<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="x2FM-RM-TTL" id="toc_marker-2"><a href="#/text/9780062292742_Contents#From_the_Editor_toc"><span class="CT-hyperlink">From the Editor</span></a></p>
<p class="x1BM-FIRST"><span class="dropcap">I</span>t gives me great pleasure to introduce a new platform for <em class="italic">The Wall Street Journal</em>’s peerless journalism: e-books, published in conjunction with our sister company, HarperCollins.</p>
<p class="x1BM">Our first such venture tells the remarkable story of the ascent of the new head of the Catholic Church. “Pope Francis” represents the quality, depth, timeliness and resources that readers have come to expect of the <em class="italic">Journal</em>, told in the objective narrative style that characterizes our most ambitious work. A rich and in-depth look at Cardinal Jorge Mario Bergoglio, a man little known to much of the world until just a few weeks ago, here is a truly collaborative effort between some of our top reporters and editors around the world, who brought their extensive experience to the project.</p>
<p class="x1BM">In Rome, correspondent Stacy Meichtry and Italy bureau chief Alessandra Galloni tapped their deep sources inside the Vatican to document the challenges facing this two-millennia-old church, and the events that led to the dramatic selection of the first-ever New World pope. In Argentina, reporters John Lyons, Matt Moffett, José de Córdoba and Loretta Chao, working with Latin America chief David Luhnow, tracked down friends, colleagues, critics and observers of the new pope in an effort to understand and explain Francis’s life, career and perspective.</p>
<p class="x1BM">“Pope Francis” inaugurates a new way for us to bring you <em class="italic">Journal</em> journalism, with greater depth than the daily newspaper allows. We’re very excited at the chance to bring this book to you, and we look forward to more in the future. We’d also like to hear from all of you on how we’ve done and what you’d like to see us tackle in the future.</p>
<p class="x1BM">Thank you for reading “Pope Francis” and <em class="italic">The Wall Street Journal</em>.</p>
<p class="x1SIG-FIRST">Yours,</p>
<p class="x1SIG-MID">Gerard Baker</p>
<p class="x1SIG-LAST">Editor in Chief</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062292742_From_Editor.vue?276b8e4a